import { render, staticRenderFns } from "./UsuarioContribuinte.vue?vue&type=template&id=23954d37&scoped=true&"
import script from "./UsuarioContribuinte.vue?vue&type=script&lang=js&"
export * from "./UsuarioContribuinte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23954d37",
  null
  
)

export default component.exports